/**
 * props: 
 * @property {string|number} height height iframe
 * @property {string|number} width width iframe
 * @property {string} url iframe url
 */

const IFrame = (props) => {
    const {height, width, url} = props
    return (<div style={{ height: height, width: width }}> 
        <iframe
            id='iframeChatbot'
            src={url}
            width='100%'
            height='100%'
            frameBorder='0'
            title='Chatbot Viewer'
            allow='clipboard-read; clipboard-write'
        />
    </div>)
}

export { IFrame as default }